import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import ShowRoleTypesInteractor from "../interactor/roles/ShowRoleTypesInteractor";
import PositionTypesPage from "../ui/pages/positions/PositionTypesPage";
import ShowPositionTypesInteractor from "../interactor/position/ShowPositionTypesInteractor";
import ShowFormTypesInteractor from "../interactor/formconfiguration/ShowFormTypesInteractor";
import FormTypesPage from "../ui/pages/formconfiguration/FormTypesPage";
import ShowFormTypesGroupCategoriesInteractor from "../interactor/formconfiguration/ShowFormTypesGroupCategoriesInteractor";
import FormTypesGroupCategoriesPage from "../ui/pages/formconfiguration/FormTypesGroupCategoriesPage";
import FormConfigurationPage from "../ui/pages/formconfiguration/FormConfigurationPage";
import ShowFormConfigurationInteractor from "../interactor/formconfiguration/ShowFormConfigurationInteractor";
import RoleTypesPage from "../ui/pages/roles/RoleTypesPage";
import ReportingTypesPage from "../ui/pages/reporting/ReportingTypesPage";
import ShowReportingTypesInteractor from "../interactor/reporting/ShowReportingTypesInteractor";
import MenuItemsPage from "../ui/pages/menu/MenuItemsPage";
import ShowMenuItemsInteractor from "../interactor/menu/ShowMenuItemsInteractor";
import SystemParametersPage from "../ui/pages/systemparameter/SystemParametersPage";
import ShowSystemParametersInteractor from "../interactor/systemparameter/ShowSystemParametersInteractor";
import FactsPage from "../ui/pages/evaluation/FactsPage";
import ShowFactsInteractor from "../interactor/evaluation/ShowFactsInteractor";
import ShowBusinessRulesInteractor from "../interactor/evaluation/ShowBusinessRulesInteractor";
import BusinessRulesPage from "../ui/pages/evaluation/BusinessRulesPage";
import RuleGroupsPage from "../ui/pages/evaluation/RuleGroupsPage";
import ShowRuleGroupsInteractor from "../interactor/evaluation/ShowRuleGroupsInteractor";
import ShowEvaluationTypesInteractor from "../interactor/evaluation/ShowEvaluationTypesInteractor";
import EvaluationTypesPage from "../ui/pages/evaluation/EvaluationTypesPage";
import ShowRequestTypesInteractor from "../interactor/requests/ShowRequestTypesInteractor";
import RequestTypesPage from "../ui/pages/requests/RequestTypesPage";
import AttributeCodebookPage from "../ui/pages/valuelist/AttributeCodebookPage";
import ShowAttributeCodebookInteractor from "../interactor/valuelist/ShowAttributeCodebookInteractor";
import { RoleConstants } from "../common/Constants";
import ShowDynamicQueriesInteractor from "../interactor/dynamicQuery/ShowDynamicQueriesInteractor";
import DynamicQueriesPage from "../ui/pages/dynamicQuery/DynamicQueriesPage";

export default class CodebookArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/codebooks/roles",
        page: this.createPage({
          Page: RoleTypesPage,
          action: this.showRolesTypePage.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/positions",
        page: this.createPage({
          Page: PositionTypesPage,
          action: this.showPositionTypesPage.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/reporting",
        page: this.createPage({
          Page: ReportingTypesPage,
          action: this.showReportingTypesPage.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/form-types",
        page: this.createPage({
          Page: FormTypesPage,
          action: this.showFormTypesPage.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/form-types-group-categories",
        page: this.createPage({
          Page: FormTypesGroupCategoriesPage,
          action: this.showFormTypesGroupCategories.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/form-types/:formTypeCode/configuration",
        page: this.createPage({
          Page: FormConfigurationPage,
          action: this.showFormConfiguration.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN],
          initialProps: {
            style: {
              padding: 0
            }
          }
        }
      },
      {
        path: "/codebooks/system-parameters",
        page: this.createPage({
          Page: SystemParametersPage,
          action: this.showSystemParameters.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks",
        page: this.createPage({
          Page: SystemParametersPage,
          action: this.showSystemParameters.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/facts",
        page: this.createPage({
          Page: FactsPage,
          action: this.showFacts.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN],
          initialProps: {}
        }
      },
      {
        path: "/codebooks/business-rules",
        page: this.createPage({
          Page: BusinessRulesPage,
          action: this.showBusinessRules.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN],
          initialProps: {}
        }
      },
      {
        path: "/codebooks/rule-groups",
        page: this.createPage({
          Page: RuleGroupsPage,
          action: this.showRuleGroups.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN],
          initialProps: {}
        }
      },
      {
        path: "/codebooks/evaluation-types",
        page: this.createPage({
          Page: EvaluationTypesPage,
          action: this.showEvaluationTypes.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN],
          initialProps: {}
        }
      },
      {
        path: "/codebooks/request-types",
        page: this.createPage({
          Page: RequestTypesPage,
          action: this.showRequestTypes.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN],
          initialProps: {}
        }
      },
      {
        path: "/codebooks/menu-items",
        page: this.createPage({
          Page: MenuItemsPage,
          action: this.showMenuItemsPage.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/attributes",
        page: this.createPage({
          Page: AttributeCodebookPage,
          action: this.showAttributeCodebookPage.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      },
      {
        path: "/codebooks/dynamic-queries",
        page: this.createPage({
          Page: DynamicQueriesPage,
          action: this.showDynamicQueries.bind(this)
        }),
        options: {
          secure: true,
          role: [RoleConstants.MIK_BO.MIK_ADMIN]
        }
      }
    );
  }

  public showDynamicQueries() {
    return this.application.container
      .resolve<ShowDynamicQueriesInteractor>("showDynamicQueries")
      .execute();
  }

  public showSystemParameters() {
    return this.application.container
      .resolve<ShowSystemParametersInteractor>("showSystemParameters")
      .execute();
  }

  public showRolesTypePage() {
    return this.application.container
      .resolve<ShowRoleTypesInteractor>("showRoleTypes")
      .execute();
  }

  public showPositionTypesPage() {
    return this.application.container
      .resolve<ShowPositionTypesInteractor>("showPositionTypes")
      .execute();
  }

  public showFormTypesPage() {
    return this.application.container
      .resolve<ShowFormTypesInteractor>("showFormTypes")
      .execute();
  }

  public showFormTypesGroupCategories() {
    return this.application.container
      .resolve<ShowFormTypesGroupCategoriesInteractor>(
        "showFormTypesGroupCategories"
      )
      .execute();
  }

  public showFormConfiguration(params: any) {
    return this.application.container
      .resolve<ShowFormConfigurationInteractor>("showFormConfiguration")
      .execute(params.formTypeCode);
  }

  public showReportingTypesPage() {
    return this.application.container
      .resolve<ShowReportingTypesInteractor>("showReportingTypes")
      .execute();
  }

  public showMenuItemsPage() {
    return this.application.container
      .resolve<ShowMenuItemsInteractor>("showMenuItems")
      .execute();
  }

  public showFacts() {
    return this.application.container
      .resolve<ShowFactsInteractor>("showFacts")
      .execute();
  }

  public showBusinessRules() {
    return this.application.container
      .resolve<ShowBusinessRulesInteractor>("showBusinessRules")
      .execute();
  }

  public showRuleGroups() {
    return this.application.container
      .resolve<ShowRuleGroupsInteractor>("showRuleGroups")
      .execute();
  }

  public showEvaluationTypes() {
    return this.application.container
      .resolve<ShowEvaluationTypesInteractor>("showEvaluationTypes")
      .execute();
  }

  public showRequestTypes() {
    return this.application.container
      .resolve<ShowRequestTypesInteractor>("showRequestTypes")
      .execute();
  }

  public showAttributeCodebookPage() {
    return this.application.container
      .resolve<ShowAttributeCodebookInteractor>("showAttributeCodebook")
      .execute();
  }
}
